import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2TourInvitationDialogProperties extends BasicDialogProperties {
    public tournamentId: number = 0;
    public runtime: number = NaN;
    public name: string;
    public round: number = 0;

    constructor(tournamentId: number, runtime: number, name: string, round: number) {
        super();
        this.tournamentId = tournamentId;
        this.runtime = runtime;
        this.name = name;
        this.round = round;
    }
}
